import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-send-assessment-results-modal',
  templateUrl: './send-assessment-results-modal.component.html'
})
export class SendAssessmentResultsModalComponent implements OnInit {

  modalData: any;
  public onClose: Subject<any>;

  jobMatchDetailsArray: any[] = [];
  sendResultsArray: any[] = [];
  label = 'Send Assessment Results';
  callbackObject = {
    callbackType: 'cancel',
    entity: {}
  };

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit(): void {
    this.jobMatchDetailsArray = this.modalData && this.modalData.jobMatchDetailsArray ? this.modalData.jobMatchDetailsArray : [];
    this.sendResultsArray = this.modalData && this.modalData.sendResultsArray ? this.modalData.sendResultsArray : [];

    this.sendResultsArray.forEach((val: any) => {
      const jobMatchInfo = this.jobMatchDetailsArray.find(
        (item: any) => item.jobMatchId === val.jobMatchId
      );

      if (jobMatchInfo) {
        val.name = jobMatchInfo.jobMatchData.name;
      }
    });
  }

  closeModal(): void {
    this.callbackObject.callbackType = 'close';
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }

  dismissModal(): void {
    this.onClose.next(null);
    this.bsModalRef.hide();
  }

}
